"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colors = exports.dataVizColorsText = exports.dataVizColors = void 0;
var primary = "#00223D";
var secondary = "#526070";
var tertiary = "#30133E";
var primaryContainer = "#184469";
var onPrimary = "#BBDAFF";
var secondaryContainer = "#D9E8FC";
var onSecondary = "#3E4C5B";
var tertiaryContainer = "#533461";
var onTertiary = "#F0C8FF";
var surfaceContainer = "#EEEDF1";
var surfaceContainerLow = "#F3F3F7";
// const grey80 = '#333333'
// const grey40 = "#999999"
// const grey10 = "#E7E7E7"
var grey2 = '#00000005';
var grey5 = '#0000000D';
var grey10 = '#0000001A';
var grey20 = '#00000033';
var grey30 = '#0000004D';
var grey40 = '#00000066';
var grey50 = '#00000080';
var grey60 = '#00000099';
var grey70 = '#000000B3';
var grey80 = '#000000CC';
var grey90 = '#000000E6';
var black = '#000000';
var white = "#ffffff";
var blue = "#2F55FF";
var yellow = "#DA9A0F";
var yellowBG = "#FFF7DC";
var yellowStroke = "#FFE09A";
var redBG = "#FFE3E3";
var red = "#800";
// const green = "#159300";
var purple = "#9D13E8";
var error = "#C41717";
var success = "#53AC00";
var shadowDefault = "#0000000f";
var shadowHover = "#0000001f";
var hintHover = "#F4E8C3";
var hint = "#B77222";
var green = '#53AC00';
var greenBG = '#E8F6DA';
var greenStroke = '#C4DAAF';
exports.dataVizColors = [
    "#FF665D",
    "#4DBC5D",
    "#F89700",
    "#49A3FF",
    "#E5BF01",
    "#2ABBB5",
    "#AC8E68",
    "#CF8AF2",
];
exports.dataVizColorsText = [
    "#E92519",
    "#0A8D1E",
    "#C57800",
    "#197BDE",
    "#997F00",
    "#13918C",
    "#93662D",
    "#B554E6",
];
exports.colors = {
    primary: primary,
    secondary: secondary,
    tertiary: tertiary,
    primaryContainer: primaryContainer,
    onPrimary: onPrimary,
    secondaryContainer: secondaryContainer,
    onSecondary: onSecondary,
    tertiaryContainer: tertiaryContainer,
    onTertiary: onTertiary,
    surfaceContainer: surfaceContainer,
    surfaceContainerLow: surfaceContainerLow,
    grey2: grey2,
    grey5: grey5,
    grey10: grey10,
    grey20: grey20,
    grey30: grey30,
    grey40: grey40,
    grey50: grey50,
    grey60: grey60,
    grey70: grey70,
    grey80: grey80,
    grey90: grey90,
    black: black,
    white: white,
    yellow: yellow,
    blue: blue,
    yellowBG: yellowBG,
    yellowStroke: yellowStroke,
    success: success,
    error: error,
    hintHover: hintHover,
    hint: hint,
    purple: purple,
    shadowDefault: shadowDefault,
    shadowHover: shadowHover,
    green: green,
    greenBG: greenBG,
    greenStroke: greenStroke,
    redBG: redBG,
    red: red
};
